var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlateIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.93,28a1.07,1.07,0,0,1-.46-.11,1,1,0,0,1-.42-1.35,26.89,26.89,0,0,1,18.76-14,1,1,0,0,1,.38,2,24.85,24.85,0,0,0-17.37,13A1,1,0,0,1,11.93,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.78,8.24a5,5,0,1,0-7.56,0A31,31,0,0,0,4,39H6a29,29,0,0,1,58,0h2A31,31,0,0,0,38.78,8.24ZM32,5a3,3,0,1,1,3,3A3,3,0,0,1,32,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69,41H1a1,1,0,0,0-1,1,5,5,0,0,0,5,5h.59l-4,4H0v2H2a1,1,0,0,0,.71-.29L8.41,47H29a3,3,0,0,1,0,6H15a1,1,0,0,0,0,2H29a4.84,4.84,0,0,0,2.08-.46h0l14.57-7.16a3,3,0,0,1,4,1.34A2.94,2.94,0,0,1,49.87,51a3,3,0,0,1-1.5,1.74L29.88,62H0v2H30.12a1,1,0,0,0,.45-.11l18.7-9.37a5,5,0,0,0,2.24-6.71A4.86,4.86,0,0,0,51,47H65a5,5,0,0,0,5-5A1,1,0,0,0,69,41ZM33.91,50.92v0A4.83,4.83,0,0,0,34,50a4.92,4.92,0,0,0-1-3h8.92ZM65,45H5a3,3,0,0,1-2.83-2H67.83A3,3,0,0,1,65,45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlateIco);
export default __webpack_public_path__ + "static/media/plate-ico.225de8c9edcf1e6e25dd334cb944b0b8.svg";
export { ForwardRef as ReactComponent };